import { cache } from 'react'
import { jsonGetFetcher } from '@/src/fetchers'

export const getChallenge = cache(async (challengeId) => {
  let url = `${process.env.API}/challenges/${challengeId}`
  return jsonGetFetcher([url])
})
